{
  "hello": "Hello {name}!",
  "log-in-title": "Enter your credentials to log in",
  "log-in-data-not-correct": "Invalid username or password",
  "log-in-forgot": "Forgot your password?",
  "log-in": "Log in",
  "log-in-code-error": "Enter the code again.",
  "log-in-code-label": "Enter the generated TOTP code into your authenticator app",
  "mfa-intro": "To complete the Log in process it is necessary to activate multi-factor authentication. You can use two alternative modes:",
  "mfa-list-intro": "<ul><li>Scan the «QR CODE»</li><li>Or click on «Detect code» and enter it into your authentication app</li></ul><div>Finally, enter the code generated by the app below. If you need support, contact <a href=\"mailto:login@coreconsulting.it\">login@coreconsulting.it</a></div>",
  "code-reveal": "DETECT CODE",
  "code-label": "Enter the code generated by the app here",
  "code-not-valid": "The code entered is invalid.",
  "confirm": "Confirm",
  "new-pswrd-title": "Choose your new password",
  "pswrd-not-match": "The passwords don't match",
  "password-char": "The password must contain at least {length} characters",
  "password-numbers": ", a number",
  "password-uppercase": ", a capital letter",
  "password-special": ", a special character",
  "password-rejected": "The password was not accepted. {message}",
  "onboarding": "Onboarding",
  "reset-username": "Enter your username",
  "reset-password": "Reset password",
  "send": "Send",
  "submission-error": "Request unsuccessful, try again",
  "verify-code-send": "If the username you entered is valid, you will receive a verification code to your email address. If you have not received the email, check your spam or contact <a href=\"mailto:login@coreconsulting.it\">login@coreconsulting.it</a>",
  "insert-code": "Enter the code here",
  "insert-code-again": "Enter the code again",
  "choose-password": "Choose your password",
  "copy-code-success": "Code copied to clipboard",
  "mfa": "Multi-factor authentication",
  "confirm-password": "Confirm Password",
  "username": "Username",
  "back": "Back",
  "log-in-no-provider": "No login provider specified. Please access this page through your application's link.",
  "error-not-found-title": "Page not found",
  "error-generic-title": "Something went wrong",
  "error-guidance": "Please access this service through your application's link.",
  "home-title": "Coreconsulting Identity Service",
  "home-intro": "This is the Coreconsulting identity and authentication service. It exists to sign users into the applications that rely on it, and is not meant to be visited on its own.",
  "home-guidance": "If you have reached this page directly, please return to the application you were using and follow its sign-in link. Access to this service is only meaningful when it is initiated by a connected application.",
  "auth-redirecting-to": "Redirecting to",
  "auth-continue": "Continue",
  "auth-not-you": "Not you? Go back to login",
  "auth-redirecting-in": "Redirecting to {host} in {seconds} seconds",
  "auth-redirecting-now": "Redirecting to {host}…",
  "auth-already-in": "You have already entered the platform",
  "auth-back-to-login": "Back to the login page"
}
